import { useMutationState, useQuery } from '@tanstack/react-query';

import { mutationKeys, subscriptionMeOptions } from '@/entities/subscription';

export function useIsCancellationProcessing(): boolean {
    const { data: subscription } = useQuery(subscriptionMeOptions());
    const cancellations = useMutationState({
        filters: { mutationKey: mutationKeys.cancelPlan() },
        select: (mutation) => mutation.state,
    });
    const reactivatedAt = useMutationState({
        filters: { mutationKey: mutationKeys.reactivate() },
        select: (mutation) => mutation.state.submittedAt,
    });

    const lastReactivatedAt = Math.max(0, ...reactivatedAt);

    const isRequestPending = cancellations.some((state) => state.status === 'pending');
    // A cancellation that settled before the last reactivate has since been undone. Counting it
    // would re-arm this the moment reactivating flips cancelAtPeriodEnd back to false.
    const hasRequestSucceeded = cancellations.some(
        (state) => state.status === 'success' && state.submittedAt > lastReactivatedAt,
    );

    return isRequestPending || (hasRequestSucceeded && !subscription?.cancelAtPeriodEnd);
}
